/**
 * Represents a service that provides internationalization support.
 */
export const I18nService = Symbol('I18nService');
